export default import.meta.ROLLDOWN_FILE_URL_vNKS9BXew4q2HmjGm8GLsQ